'use strict';

Object.defineProperty(exports, "__esModule", {
				value: true
});

var _jquery = require('jquery');

var _jquery2 = _interopRequireDefault(_jquery);

var _magnificPopup = require('magnific-popup');

var _magnificPopup2 = _interopRequireDefault(_magnificPopup);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function () {
				(function (MagnificPopup, $) {
								var $dom = {};

								var cacheDom = function cacheDom() {
												$dom.popup = $('[data-popup-trigger]');
								};

								var bindUIActions = function bindUIActions() {
												$dom.popup.magnificPopup({
																type: 'inline',
																preloader: false,
																removalDelay: 500,
																focus: '#name',
																callbacks: {
																				open: function open() {
																								this.ev.find('video').trigger('pause');
																								this.content.find('video').trigger('play');
																				},
																				close: function close() {
																								this.content.find('video').trigger('pause');
																								this.ev.find('video').trigger('play');
																				}
																}
												});
								};

								MagnificPopup.init = function () {
												cacheDom();
												bindUIActions();
								};
				})(window.MagnificPopup = window.MagnificPopup || {}, _jquery2.default, undefined);
};